// extracted by mini-css-extract-plugin
export default {"container":"BreedsPage_container__dX7zi","list_container":"BreedsPage_list_container__N58Ov","list":"BreedsPage_list__89bep"};